module.exports = __webpack_public_path__ + "static/media/04.f0bd9736.mp3";